import type { AsyncDataOptions } from 'nuxt/app'
import HttpFactory from '../HttpFactory'
import type IBasicArrayResponse from '../interfaces/IBasicArrayResponse'

class ContentsModule extends HttpFactory {
  private RESOURCE = 'api/contents'

  async getDynamicContainersFromClient (type: string, id: number) {
    const url = `${this.RESOURCE}?type=${encodeURIComponent(type)}&id=${encodeURIComponent(id)}`

    const asyncDataOptions: AsyncDataOptions<IBasicArrayResponse> = {
      server: false,
      transform: (data) => {
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data)
          } catch (e) {
            throw new Error(`Error in "${import.meta.url}" after calling "${url}"\n\n${e}\n\n${data}`, {
              cause: e
            })
          }
        }
        return data
      }
    }

    return await this.callUseAsyncData<IBasicArrayResponse>(
      'GET',
      url,
      null,
      {},
      {},
      asyncDataOptions
    )
  }
}

export default ContentsModule
